import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { PruneSupportCriteriaNodesRequest } from '@cash-web/shared-util-protos/squareup/cash/supportal/service.pb'
import { PruneSupportCriteriaNodesResponse } from '@cash-web/shared-util-protos/squareup/cash/supportal/service.pb'

export const pruneSupportCriteriaNodes = (request: PruneSupportCriteriaNodesRequest, options?: CashRequestOptions) =>
  post<PruneSupportCriteriaNodesRequest, PruneSupportCriteriaNodesResponse>(
    '/2.0/cash/prune-support-criteria-nodes',
    request,
    { ...options, rejectOnError: true }
  )
